import { TranslocoService } from '@jsverse/transloco';
import { SimpleDialogData } from '../components/dialogs/simple-alert-dialog/simple-alert-dialog.component';

export const HTTP_STATUS_LOCKED = 423;

export const isDatasetLockedError = (error: any): boolean => error?.status === HTTP_STATUS_LOCKED;

export const getLockedByMessage = (error: any, translateService: TranslocoService): string | undefined => {
  const locks = Array.isArray(error?.error) ? error.error : error?.error?.locks;
  const lockedBy: string | null | undefined = locks?.[0]?.lockedBy;
  return lockedBy ? translateService.translate('errors.datasetLockedBy', { user: lockedBy }) : undefined;
};

export const getDatasetLockedDialogData = (error: any, translateService: TranslocoService): SimpleDialogData => {
  const messages = [
    translateService.translate('errors.datasetLocked'),
    getLockedByMessage(error, translateService)
  ].filter((message): message is string => !!message);
  return { title: translateService.translate('common.text.locked'), messages, icon: 'desktop_access_disabled' };
};
